import { useState, useEffect } from "react";
import { API_BASE_URL, submitFormData } from "../config/config";
import { useNavigate } from "react-router-dom";


const CreditReport = () => {
     const navigate = useNavigate();

    const [countries, setCountries] = useState([]);
    const [document, setDocument] = useState([]);
    const [documentOptions, setDocumentOptions] = useState([]);
         

    const deliveryMethods = ["WhatsApp", "Telegram", "Jabber", "E-mail"];
    const [selectCountry, setSelectCountry] = useState("");
    const [selectOption, setSelectOption] = useState('');
    const [selectPrice, setSelectPrice] = useState(0);
    const [selectDeliveryMethod, setSelectDeliveryMethod] = useState('');





    useEffect(() => {
        // document ki jagah window.document use karein
        const inputs = window.document.querySelectorAll('input[required], select[required]');
        
        inputs.forEach(input => {
            input.oninvalid = (e) => {
                e.target.setCustomValidity("Complete this section.");
            };
            input.oninput = (e) => {
                e.target.setCustomValidity("");
            };
        });
    }, [selectDeliveryMethod, documentOptions]);



   

  const getData = async () => {
    let slug = "ssn-dob";
    try {
      const response = await fetch(`${API_BASE_URL}/get-options?slug=${slug}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      const result = await response.json();
      if (result.success == 1) {
        setSelectCountry(result.countries[0].name);
        setCountries(result.countries);
        setDocument(result.documents[0] || {});
        setDocumentOptions(result.countries[0].document_options);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleForm = (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const formEntries = Object.fromEntries(formData.entries());

    // Data packaging
    const allOrderData = {
      ...formEntries,
      select_country: selectCountry,
      select_document_type: selectOption,
      price: selectPrice,
      delivery_method: selectDeliveryMethod,
      service_type: "Background Report",
      category_slug: "background-report",
    };

    // Checkout redirect
    navigate(
      `/checkout?price=${selectPrice}&plan=${encodeURIComponent(selectOption)}`,
      {
        state: { orderData: allOrderData },
      },
    );
  };

    useEffect(() => {
        getData();
    }, [])

    return (
        <>
            <div className="passport-container">
                <div className="product-main">
                    <div className="product-image-box">
                        <div className="placeholder-img">
                            <img src={document.image_path || ''} alt={document.title || 'Passport Service'} />
                        </div>
                    </div>

                    <div className="product-info">
                        <h2 className="prod-title">United States SSN + DOB Lookup</h2>

                       {/* 1. SELECT COUNTRY */}
            <div className="field-group" style={{ display: "none" }}>
              <label>Select Document Country</label>
              <select
                required
                onChange={(e) => {
                  const countryId = e.target.value;
                  const selectedCountry = countries.find(
                    (c) => c.id == countryId,
                  );
                  if (selectedCountry) {
                    setSelectCountry(selectedCountry.name);
                    setDocumentOptions(selectedCountry.document_options);
                  } else {
                    setSelectCountry("");
                    setDocumentOptions([]);
                  }
                }}
              >
                {countries.map((country, index) => (
                  <option key={index} value={country.id}>
                    {country.name}
                  </option>
                ))}
              </select>
            </div>

                        {/* 2. SELECT DOCUMENT TYPE */}
                        {documentOptions.length > 0 ? (
                            <div className="field-group">
                                <label>Select Service Type  </label>
                                <select
                                    required
                                    onChange={(e) => {
                                        const optionId = e.target.value || 0;
                                        const selectedOption = documentOptions.find(
                                            option => option.id == optionId
                                        );

                                        if (selectedOption) {
                                            setSelectOption(selectedOption.title);
                                            setSelectPrice(selectedOption.price);
                                        } else {
                                            setSelectOption('');
                                            setSelectPrice(0);
                                        }
                                    }}
                                >
                                    <option value="">Choose Document Type...</option>
                                    {documentOptions.map((option, index) => (
                                        <option key={index} value={option.id}>{option.title} ${option.price}</option>
                                    ))}
                                </select>
                            </div>
                        ) : null}

                        {/* TOTAL PRICE CALCULATOR DISPLAY */}
                        {selectPrice > 0 && (
                            <div className="total-price-box" style={{
                                margin: '15px 0',
                                padding: '12px',
                                backgroundColor: '#f8f9fa',
                                borderLeft: '4px solid #000',
                                fontSize: '18px'
                            }}>
                                <strong>Total Price: ${selectPrice}</strong>
                            </div>
                        )}

                        {/* 3. DELIVERY METHOD */}
                        {selectPrice > 0 && (
                            <div className="field-group">
                                <label>Select Delivery Method</label>
                                <select
                                    required
                                    onChange={(e) => {
                                        setSelectDeliveryMethod(e.target.value);
                                    }}
                                >
                                    <option value="">Choose...</option>
                                    {deliveryMethods.map((m) => (
                                        <option key={m} value={m}>{m}</option>
                                    ))}
                                </select>
                            </div>
                        )}

                        {/* 4. ORDER DETAILS FORM */}
                        {selectDeliveryMethod && (
                            <form className="order-details-box modern-card" onSubmit={handleForm}>
                                <h3>Order Details</h3>

                                <div className="input-grid" >
                                    <input
                                        name="delivery"
                                        required
                                        placeholder={`Enter your ${selectDeliveryMethod} for delivery`}
                                        className="full-width"
                                    />
                                    
                                    <input 
                                        name="f_name"
                                        required
                                        placeholder="First Name"
                                    />
                                    <input 
                                        name="l_name"
                                        required
                                        placeholder="Last Name"
                                    />
                                    <input 
                                        name="address"
                                        required
                                        placeholder="Full address"
                                    />
                                    <input name="city" required placeholder="City" />
                                    <input name="state" required placeholder="State" />
                                    <input name="zip_code" required placeholder="Zip Code" />

                                    
 <textarea
                                                name="instructions"
                                                placeholder="Extra Instructions (Optional)"
                                                className="full-width"
                                            />
                                    
                                </div>

                                <div>
                                    <button type="submit" className="buy-btn">PROCEED TO CHECKOUT</button>
                                </div>
                            </form>
                        )}
                    </div>
                </div>

                <div className="product-description">
                    <h4 className="mt-4">Product Details</h4>
                    <div dangerouslySetInnerHTML={{
                        __html: document.content || ''
                    }}></div>
                </div>
            </div>
        </>
    );
}

export default CreditReport;


























